import { getContext } from 'svelte';

export const flagsContextKey = Symbol();

export type FlagsContext = Record<string, boolean>;

export const flagValue = (key: string) => {
  const ctx = getContext<FlagsContext>(flagsContextKey);

  return !!ctx[key];
};
